import React from 'react'
import { Divider, makeStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import moment from 'moment/moment'
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12
  },
  name: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    color: PRIMARY_COLORS[700]
  },
  date: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    color: GRAY_COLORS[400]
  },
  text: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    color: GRAY_COLORS[700]
  }
}))
const CommentItem = ({ comment, isLast = false }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {!!comment?.text && (
        <>
          <div className={classes.row}>
            <div className={classes.name}>{comment?.userFullName}</div>
            <div className={classes.date}>
              {moment(comment?.createdDate).utc(0).format('HH:mm DD.MM.YYYY')}
            </div>
          </div>
          <div
            className={classes.row}
            style={{
              marginTop: 5
            }}
          >
            <div className={classes.text}>{comment?.text}</div>
          </div>
        </>
      )}
      {!isLast && (
        <Divider
          style={{
            marginTop: 12,
            marginBottom: 12
          }}
        />
      )}
    </div>
  )
}
export default CommentItem
